//src/redux/slices/userProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserInfo {
  biography: string;
  club: string;
  email: string;
  date_of_birth: string | null;
  name: string;
  username: string;
  phone_number: string;
  location: string;
  local_play: string;
  profile_picture: string;
  gender: string;
  subscription_type: string;
  date_joined: string; // 🔧 Mudança: Date -> string para serializabilidade Redux
  subscription_expiration: string; // 🔧 Mudança: Date -> string para serializabilidade Redux
  id: number;
}

interface UserProfileState {
  userProfile: UserInfo | null;
}

const initialState: UserProfileState = {
  userProfile: null,
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<UserInfo>) => {
      state.userProfile = action.payload;
    },
    resetUserProfile: (state) => {
      state.userProfile = null;
    },
  },
});

export const { setUserProfile, resetUserProfile } = userProfileSlice.actions;
export default userProfileSlice.reducer;
